import { collect } from "react-recollect"
import { getLangType, getMaskNameColor, getMaskDisplayName, getMaskCushionSize, getMaskFrameSize } from '../utils/utils'
import { Row, Col } from 'reactstrap'
import Select from 'react-select'
import { languageOptions } from '../language'
import MaskRecommendationRadioButton from './MaskRecommendationRadioButton'

const langType = getLangType()
const ScriptedMaskOption = ({ store, readOnly, getScriptedMaskResults, isRecommendedMask, setRecommendedMask, handleCushionSize, handleFrameSize }) => {
  const isScriptedPtCompleted = store.selectedRow.status === 'RX - Completed'
  const prescription = store.selectedRow.refits.filter(refit => refit.switch_reason === 'prescription')[0];
  const maskResult = getScriptedMaskResults();

  const scriptedMaskResult = {
    name: prescription?.switched_to_mask_type,
    cushion_size: prescription?.switched_to_mask_size,
    frame_size: prescription?.switched_to_mask_frame_size,
    chin_strap: false
  }

  return (
    <div>
      <div className='d-xl-none'><small><strong>Scripted Mask</strong></small></div>
      <Row className="d-none d-xl-flex">
        <Col xl={6}>
          <small><strong>Scripted Mask</strong></small>
        </Col>
        {isScriptedPtCompleted &&
          <Col xl={6}>
            <Row>
              <Col lg={5}>
                <small><strong>
                  {store.selectedRow.refits?.filter(refit => refit.switch_reason === 'prescription').length > 1 ? 'Current' : 'Scripted'}
                </strong></small>
              </Col>
              {store.selectedRow.model_output &&
                <Col lg={7} className='p-0'>
                  <small><strong>Recommended</strong></small>
                </Col>
              }
            </Row>
          </Col>
        }
      </Row>
      {prescription && (
        <div className='recommendedMasks-container' >
          <Row
            className={(!readOnly && !store.selectedRow.voided_at) ?
              "recommendationSelectRow" : 'recommendationSelectRowNoHover'}
          >
            <Col xl={6} className="mask-info mb-2 mb-xl-0">
              <div className="mask-check">
                {(!readOnly && !store.selectedRow.voided_at) &&
                  <MaskRecommendationRadioButton
                    maskName={prescription?.switched_to_mask_type}
                    checked={!store.selectedRow.model_output || isRecommendedMask(scriptedMaskResult)}
                    handleChange={() => setRecommendedMask(scriptedMaskResult)}
                    color={getMaskNameColor(prescription?.switched_to_mask_type)}
                    disabled={!store.selectedRow.model_output}
                    label={
                      // If scripted is 'Other' and has a name include it.
                      <strong style={{ color: getMaskNameColor(prescription?.switched_to_mask_type) }}>
                        {(prescription?.switched_to_mask_type === 'Other' && prescription?.switched_to_mask_type_other) ?
                          `Other (External): ${prescription?.switched_to_mask_type_other}` :
                          getMaskDisplayName(prescription?.switched_to_mask_type)}
                      </strong>
                    }
                  />}
              </div>
            </Col>
            <Col xl={6}>
              <Row className='justify-content-between mb-1'>
                <Col lg={5} className='d-flex align-items-center'>
                  {languageOptions.cushionSize[langType]}:&nbsp;<strong>{prescription?.switched_to_mask_size}</strong>
                </Col>
                {isScriptedPtCompleted && store.selectedRow.model_output &&
                  <Col lg={7}>
                    <Row className='align-items-center'>
                      <Col xs={6} xl={7} className='p-xl-0'>Cushion Change:</Col>
                      <Col xs={6} xl={5} className='p-xl-0'><Select
                        isDisabled={store.selectedRow.voided_at}
                        onChange={handleCushionSize}
                        options={getMaskCushionSize(scriptedMaskResult.name)}
                        defaultValue={{ value: maskResult?.cushion_size, label: maskResult?.cushion_size }} />
                      </Col>
                    </Row>
                  </Col>}
              </Row>
              <Row className='justify-content-between mb-1'>
                <Col lg={5} className='d-flex align-items-center'>
                  {languageOptions.frameSize[langType]}:&nbsp;<strong>{prescription?.switched_to_mask_frame_size}</strong>
                </Col>
                {isScriptedPtCompleted && store.selectedRow.model_output &&
                  <Col lg={7}>
                    <Row className='align-items-center'>
                      <Col xs={6} xl={7} className='p-xl-0'>Frame Change:</Col>
                      <Col xs={6} xl={5} className='p-xl-0'><Select
                        isDisabled={store.selectedRow.voided_at}
                        onChange={handleFrameSize}
                        options={getMaskFrameSize(scriptedMaskResult.name)}
                        defaultValue={{ value: maskResult?.frame_size, label: maskResult?.frame_size }} />
                      </Col>
                    </Row>
                  </Col>}
              </Row>
            </Col>
          </Row>
        </div>
      )}
    </div>
  )
}

export default collect(ScriptedMaskOption)